import { CommonGet, CommonPost } from '../../helpers/HttpClient';
import tokenDecoder from '../../utils/tokenDecoder';

export default {
  getAllGroups,
  getFactoryByGroupID,
  getPurchaseOrderListing,
  getRequisitionNumberForDropDown,
  getGoodsReceiveNoteDetails,
  saveGoodsReceiveNoteDetails,
  GetWarehousesByGroupIDAndFactoryID,
  getPurchaseOrderForListing,
  getActionTypeForDropDown,
  getDirectPurchaseOrderNumbersForAddDropDown,
  getDirectPurchaseOrderNumbersForListingDropDown,
  getLedgerAccountByBudgetCodeID,
  saveGeneralJournal,
  getPayVoucherCode,
  getReferenceNumber,
  saveAccountPayable,
  getGroupCodeAndFactoryCode,
  GetOtherPaybleAccountForGRN,
  GetGoodsReceivedNoteDetailsForListing,
  getChildHeadersForAccountEntriesDropDown,
  getLedgerAccountsForAccountEntriesDropDownInventory,
  getDirectPurchaseOrderForListing,
  GetGRNListingDetails,
  saveGoodsReceivedNoteWithLedger,
  GetVATAccountForGRN
};

async function saveGoodsReceivedNoteWithLedger(model) {
  const response = await CommonPost('/api/GoodsReceivedNote/SaveGoodsReceivedNoteWithLedger', null, model);
  return response;
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getFactoryByGroupID(groupID) {
  let response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  let factoryArray = [];
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getPurchaseOrderForListing(factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetPurchaseOrderListing', "factoryID=" + parseInt(factoryID));
  let data = response.data;
  let result = data.map((u) => ({ purchaseOrderNumber: u.purchaseOrderNumber, purchaseOrderID: u.purchaseOrderID }));
  return result;
}

async function getPurchaseOrderListing(factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetPurchaseOrderDetailsByFactoryID', "factoryID=" + parseInt(factoryID));
  let data = response.data;
  let result = data.map((u) => ({ purchaseOrderNumber: u.purchaseOrderNumber, purchaseOrderID: u.purchaseOrderID }));
  return result;
}

async function getRequisitionNumberForDropDown(purchaseOrderID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetRequisitionNumberForDropDown', "purchaseOrderID=" + parseInt(purchaseOrderID));
  let data = response.data;
  let result = data.map((u) => ({ requisitionNumber: u.requisitionNumber, requisitionID: u.requisitionID }));
  return result;
}

async function getGoodsReceiveNoteDetails(model) {
  const response = await CommonPost('/api/GoodsReceivedNote/GetGoodsReceivedNoteDetails', null, model);
  return response;
}

async function GetGoodsReceivedNoteDetailsForListing(model) {
  const response = await CommonPost('/api/GoodsReceivedNote/GetGoodsReceivedNoteDetailsForListing', null, model);
  return response;
}

async function GetGRNListingDetails(model) {
  const response = await CommonPost('/api/GoodsReceivedNote/GetGRNListingDetails', null, model);
  return response;
}

async function saveGoodsReceiveNoteDetails(model) {
  const response = await CommonPost('/api/GoodsReceivedNote/SaveGoodsReceivedNoteDetails', null, model);
  return response;
}

async function GetWarehousesByGroupIDAndFactoryID(groupID, estateID) {
  const response = await CommonGet('/api/Requisition/GetWarehouseID', 'groupID=' + groupID + '&estateID=' + estateID)
  let wareHouses = []
  for (let item of Object.entries(response.data)) {
    wareHouses[item[1]["warehouseID"]] = item[1]["warehouseName"]
  }
  return wareHouses;
}

async function getActionTypeForDropDown() {
  const response = await CommonGet('/api/GoodsReceivedNote/GetActionTypeForDropDown', null)
  let actionTypes = [];
  for (let item of Object.entries(response.data)) {
    actionTypes[item[1]["subTransactionTypeID"]] = item[1]["subTransactionName"];
  }
  return actionTypes;
}

async function getDirectPurchaseOrderNumbersForAddDropDown(groupID, factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetDirectPurchaseOrderNumbersForAddDropDown', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  let actionTypes = [];
  for (let item of Object.entries(response.data)) {
    actionTypes[item[1]["directPurchaseOrderID"]] = item[1]["directPurchaseOrderNumber"];
  }
  return actionTypes;
}

async function getDirectPurchaseOrderForListing(groupID, factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetDirectPurchaseOrderForListing', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  let actionTypes = [];
  for (let item of Object.entries(response.data)) {
    actionTypes[item[1]["directPurchaseOrderID"]] = item[1]["dpoNumber"];
  }
  return actionTypes;
}

async function getDirectPurchaseOrderNumbersForListingDropDown(groupID, factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetDirectPurchaseOrderNumbers', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getLedgerAccountByBudgetCodeID(budgetCodeID, factoryID) {
  let response = await CommonGet('/api/GoodsReceivedNote/GetLedgerAccountByBudgetCodeID', "budgetCodeID=" + parseInt(budgetCodeID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}

async function saveGeneralJournal(generalJournal) {
  let saveModel = {
    ledgerTransactionID: 0,
    groupID: parseInt(generalJournal.groupID.toString()),
    factoryID: parseInt(generalJournal.factoryID.toString()),
    transactionTypeID: parseInt(generalJournal.transactionTypeID),
    referenceNumber: (generalJournal.referenceNumber.toString()),
    referenceNumberInter: "",
    chequeNumber: generalJournal.chequeNumber,
    voucherType: parseInt(generalJournal.voucherType),
    transactionMode: parseInt(generalJournal.transactionMode),
    voucherCode: generalJournal.referenceNumber.toString().substring(0, 2),
    recipientName: generalJournal.recipientName,
    isActive: true,
    journalData: generalJournal.journalData,
    date: generalJournal.date,
    dueDate: generalJournal.dueDate,
    createdBy: tokenDecoder.getUserIDFromToken(),
    preparedBy: tokenDecoder.getUserIDFromToken(),
    interEstateID: parseInt(generalJournal.interEstateID.toString()),
    createdDate: new Date().toISOString(),
    isInterEstate: generalJournal.isInterEstate,
    status: parseInt(generalJournal.status.toString()),
    supplierID: parseInt(generalJournal.supplierID),
    tranLedgerAccountID: parseInt(generalJournal.tranLedgerAccountID),
    modeoftransactionID: parseInt(generalJournal.modeoftransaction),
    modeoftransactionNumber: generalJournal.modeoftransactionNumber,
    payee: generalJournal.payee,
  }
  const response = await CommonPost('/api/GeneralJournal/SaveGeneralJournal', null, saveModel);
  return response;
}

async function getPayVoucherCode() {
  const response = await CommonGet('/api/VoucherType/GetPayVoucherCode', null)
  return response.data;
}

async function getReferenceNumber(model) {
  const response = await CommonGet('/api/AuditTrialReport/GetModifiedVoucherCode', 'groupID=' + model.groupID + '&factoryID='
    + model.factoryID + '&voucherYear=' + model.date + '&voucherCode=' + model.voucherCode + '&ledgerAccountTRCode=' + model.ledgerAccountTRCode);
  return response;
}


async function saveAccountPayable(model) {
  let saveModel = {
    ledgerTransactionID: 0,
    groupID: parseInt(model.groupID.toString()),
    factoryID: parseInt(model.factoryID.toString()),
    transactionTypeID: parseInt(model.transactionTypeID),
    referenceNumber: (model.referenceNumber.toString()),
    payableReferenceNumber: (model.payableReferenceNumber.toString()),
    referenceNumberInter: (model.referenceNumberInter.toString()),
    chequeNumber: model.chequeNumber,
    voucherType: parseInt(model.voucherType),
    transactionMode: parseInt(model.transactionMode.toString()),
    transactionModeName: model.transactionModeName,
    voucherCode: model.voucherCode,
    recipientName: model.recipientName,
    isActive: true,
    journalData: model.journalData,
    transactionDate: model.transactionDate,
    invoiceNo: model.invoiceNo,
    invoiceDate: model.invoiceDate,
    date: model.invoiceDate,
    dueDate: model.dueDate,
    createdBy: tokenDecoder.getUserIDFromToken(),
    preparedBy: tokenDecoder.getUserIDFromToken(),
    interEstateID: parseInt(model.interEstateID.toString()),
    isInterEstate: model.isInterEstate,
    createdDate: new Date().toISOString(),
    status: parseInt(model.status.toString()),
    supplierID: parseInt(model.supplierID.toString()),
    supplierName: model.supplierName,
    payableDescription: model.payableDescription,
    tranLedgerAccountID: parseInt(model.tranLedgerAccountID.toString()),
    tranLedgerAccountName: model.tranLedgerAccountName
  }
  const response = await CommonPost('/api/AccountPayable/SaveAccountPayable', null, saveModel);
  return response;
}

async function getGroupCodeAndFactoryCode(groupID, factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetGroupCodeAndFactoryCode',
    "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID));
  return response.data;
}

async function GetOtherPaybleAccountForGRN(factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetOtherPaybleAccountForGRN', "factoryID=" + parseInt(factoryID));
  return response.data;
}

async function getChildHeadersForAccountEntriesDropDown(factoryID) {
  var childHeaderArray = [];
  const response = await CommonGet('/api/GoodsReceivedNote/GetAllChildHeaders', "factoryID=" + parseInt(factoryID));
  for (let item of Object.entries(response.data)) {
    childHeaderArray[item[1]["childHeaderID"]] = item[1]["childHeaderName"];
  }
  const childArray = Object.entries(childHeaderArray).map(([id, name]) => ({
    id,
    name
  }));
  const sortedChildHeaders = childArray.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return sortedChildHeaders;
}

async function getLedgerAccountsForAccountEntriesDropDownInventory(factoryID, childHeaderID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetLedgerAccountsForAccountEntriesInventory', "factoryID=" + parseInt(factoryID) + "&childHeaderID=" + parseInt(childHeaderID));
  return response.data;
}

async function GetVATAccountForGRN(factoryID) {
  const response = await CommonGet('/api/GoodsReceivedNote/GetVATAccountForGRN', "factoryID=" + parseInt(factoryID));
  return response.data;
}